/* eslint-disable no-unused-vars */
import {
  IconButton,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
  TwoColumns,
} from '../../../services/settings/appStyle/global.style';
import { IntlMessages } from '../../../helper/langHelper';
import { BroadcastHeaderContainer, HeaderTitle } from '../Broadcast/broadCast.style';
import {
  getAddressBooks,
  uploadCsvToBackend,
} from '../../../services/bioplus-services/addressBook';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Table, IconButton as IconButtonWithText, Loader } from '../../../Components/uielements';
import { useMemo, useState } from 'react';
import {
  EmptyStateContainer,
  StyledEmptyStateText,
  TableEmptyState,
} from '../../../Components/uielements/table/table.style';
import { AddPlusIcon, EmptyState } from '../../../Components/icons';
import { FileInput } from './addressBook.style';
import { InviteUserModal } from '../UserV2/modals';
import { useUserContext } from '../../../hooks/UserContext';

const AddressBook = () => {
  const addressBooks = useQuery('addressBooks', () => getAddressBooks());
  const [user, setUser] = useState();
  const userContext = useUserContext();
  const companyId = userContext?.company?.companyId?.id;

  //   table coulmns
  const addressBookColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'name',
        Cell: (cellData) => (
          <TableCell>
            {`${cellData?.row?.original?.firstName} ${cellData?.row?.original?.lastName}` ?? '--'}
          </TableCell>
        ),
        width: '15%',
      },
      {
        Header: <IntlMessages id="nav.company" />,
        accessor: 'company',
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.jobTitle" />,
        accessor: 'jobTitle',
        width: '12%',
      },
      {
        Header: <IntlMessages id="table.col.department" />,
        accessor: 'department',
        width: '13%',
      },
      {
        Header: <IntlMessages id="table.col.email" />,
        accessor: 'emailAddress',
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.mobile.no" />,
        accessor: 'mobilePhone',
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.actions" defaultMessage="Actions" />,
        accessor: 'actions',
        isAction: true,
        width: '15%',
      },
    ],
    []
  );

  const actionList = [
    (data) => (
      <IconButton onClick={() => setUser(data)}>
        <IconButtonWithText
          text={<IntlMessages id="button.text.add.user" />}
          icon={<AddPlusIcon />}
        />
      </IconButton>
    ),
  ];

  const handleClosedAddUserModal = () => {
    setUser(undefined);
  };

  //   logic to upload csv
  const [isUploading, setIsUploading] = useState(false);
  const queryClient = useQueryClient();

  const uploadMutation = useMutation((payload) => uploadCsvToBackend(payload), {
    onSuccess: async () => {
      await queryClient.invalidateQueries('addressBooks');
      setIsUploading(false);
      alert('File uploaded successfully.');
    },
  });

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'text/csv') {
      const formData = new FormData();
      formData.append('file', file);

      try {
        setIsUploading(true);
        uploadMutation.mutate(formData);
      } catch (error) {
        setIsUploading(false);
        alert('Error uploading file. Please try again.');
      }
    } else {
      setIsUploading(false);
      alert('Please upload a valid CSV file.');
    }
  };
  if (addressBooks.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <BroadcastHeaderContainer>
        <HeaderTitle>
          <IntlMessages id="nav.addressBook" />
        </HeaderTitle>
        {isUploading ? (
          <>
            <Loader size="small" loadingText="Uploading..." />
          </>
        ) : (
          <TwoColumns style={{ gap: '10px' }}>
            <IconButtonWithText
              onClick={() => document.getElementById('csvUpload').click()}
              text="Upload CSV"
              icon={<AddPlusIcon />}
            />
            <FileInput id="csvUpload" type="file" accept=".csv" onChange={handleFileChange} />
          </TwoColumns>
        )}
      </BroadcastHeaderContainer>
      <TableWrapper>
        {addressBooks?.data ? (
          <Table
            data={addressBooks?.data}
            columns={addressBookColumns}
            hasFooter={false}
            actions={actionList}
          />
        ) : (
          <>
            <TableEmptyState>
              <>
                <EmptyStateContainer>
                  <EmptyState />
                </EmptyStateContainer>
                <StyledEmptyStateText size="header3">
                  <IntlMessages id="common.empty.state" defaultMessage="No Record Found" />
                </StyledEmptyStateText>
              </>
            </TableEmptyState>
          </>
        )}
      </TableWrapper>{' '}
      {user && (
        <InviteUserModal
          onClose={handleClosedAddUserModal}
          companyId={companyId}
          email={user?.emailAddress}
        />
      )}
    </StyledContainer>
  );
};

export default AddressBook;
